import ClearableQueryFilter from 'components/ClearableQueryFilter'

import useTranslations from 'hooks/translations'
import useStudent from 'hooks/student'

export default function GroupFilter (props) {

  const {translate} = useTranslations()
  const {groups} = useStudent()

  return (<ClearableQueryFilter {...{...props, caption: translate('group_label'), items: groups, name: 'clique'}} />)

}
